export const authRoleAccess = {
  dashboard: ["admin", "journalist", "informant", "user"],
  profile: ["admin", "journalist", "informant", "user"],
  adminOnly: ["admin"],
  allUsers: ["admin", "journalist", "informant", "user", "anonymous"],
};
